import { render, staticRenderFns } from "./MagazineVolumeEditVolumeInfo.vue?vue&type=template&id=620412ef&"
import script from "./MagazineVolumeEditVolumeInfo.vue?vue&type=script&lang=ts&"
export * from "./MagazineVolumeEditVolumeInfo.vue?vue&type=script&lang=ts&"
import style0 from "./MagazineVolumeEditVolumeInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports